import api, { authService } from './api';

export const artistsService = {
  listArtists: async ({ q, limit = 5000 } = {}) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get('/artists', {
        params: { q, limit },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch artists',
      };
    }
  },

  createArtist: async (payload) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post('/artists', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to create artist',
      };
    }
  },

  listAliases: async (artistId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.get(`/artists/${encodeURIComponent(artistId)}/aliases`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        items: response.data.items || [],
        totalCount: response.data.total_count || 0,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to fetch artist aliases',
      };
    }
  },

  addAlias: async (artistId, aliasName) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post(`/artists/${encodeURIComponent(artistId)}/aliases`, {
        alias_name: aliasName,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to add artist alias',
      };
    }
  },

  mergeArtist: async (sourceArtistId, targetArtistId) => {
    try {
      const token = authService.getToken();
      if (!token) throw new Error('No authentication token');

      const response = await api.post(`/artists/${encodeURIComponent(sourceArtistId)}/merge`, {
        target_artist_id: targetArtistId,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return {
        success: true,
        item: response.data.item,
        mergedArtistId: response.data.merged_artist_id,
        message: response.data.message,
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to merge artist',
      };
    }
  },
};
